import { History, LocationDescriptorObject } from "history"

type ReloadWindow = { location: { href: string; reload: () => void } }

/**
 * Lädt die App neu und öffnet dabei eine interne Route, etwa damit Polling und Seitenzustand frisch starten.
 * Die Adresse kommt aus dem Router: im iFrame `#/payment-return/…` auf der App-Seite, im Embed `?ko=/payment-return/…`
 * auf der Kundenseite. Ein absoluter App-Pfad (`/payment-return/…`) liefe auf dem Tenant-Host in einen 404
 * (nginx kennt nur `/build/`) und im Embed auf eine fremde Seite der Kundenwebsite.
 * Unterscheidet sich das Ziel nur im Hash (HashRouter-Route oder Anker der Kundenseite), springt der Browser nur
 * dorthin, deshalb dann ausdrücklich `reload()`.
 */
export function reloadAtRoute(history: History, location: LocationDescriptorObject, win: ReloadWindow = window): void {
    const href = history.createHref(location)
    const withoutHash = (url: string) => new URL(url, win.location.href).href.split("#")[0]
    const sameDocument = href.includes("#") && withoutHash(href) === withoutHash(win.location.href)
    win.location.href = href
    if (sameDocument) win.location.reload()
}
